import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ShortenWalletAddrPipe} from '../../dynamic-xyz/utils/shorten-wallet-addr.pipe';
import {L10nModule} from '../../translate';
import {DexWalletAutocompleteListComponent} from './dex-wallet-autocomplete-list.component';
import {DexWalletAutocompleteDirective} from './dex-wallet-autocomplete.directive';
import {DexWalletAutocompleteService} from './dex-wallet-autocomplete.service';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        ShortenWalletAddrPipe
    ],
    declarations: [
        DexWalletAutocompleteDirective,
        DexWalletAutocompleteListComponent
    ],
    exports: [
        DexWalletAutocompleteDirective
    ],
    providers: [
        DexWalletAutocompleteService
    ]
})
export class DexWalletAutocompleteModule {}
